import supabase from '@/services/supabaseClient';

// This post-candidate lane is compiled only into explicitly opted-in staging builds.
// Selection and merchant availability always come from the server, never currency guesses.
export const peachSandboxLane = import.meta.env.MODE === 'staging' && import.meta.env.VITE_PEACH_SANDBOX_ENABLED === 'true';
export async function appointmentPaymentRoute(serviceId) {
  if (!peachSandboxLane || !serviceId) return { selected: false };
  const { data, error } = await supabase.functions.invoke('peach-appointment-checkout', { body: { action: 'route', service_id: serviceId } });
  if (error || data?.error || typeof data?.selected !== 'boolean') throw new Error('payment_capabilities_unavailable');
  // The staging Peach lane is deliberately limited to dedicated QA identities.
  // A server-selected but unavailable lane must fall back to the normal payment
  // route for everyone else; it must never turn an ordinary checkout into a
  // false “payment unavailable” state.
  return data.selected && data.available ? data : { selected: false };
}
export async function appointmentReservationCall(action, appointmentId, locale = 'en') {
  if (peachSandboxLane) {
    const {data: route, error} = await supabase.functions.invoke('peach-appointment-checkout', {body:{action:'route',appointment_id:appointmentId}});
    if (error || route?.error || typeof route?.selected !== 'boolean') throw new Error('payment_unavailable');
    if (route.selected) {
      const result = await supabase.functions.invoke('peach-appointment-checkout', { body: { action, appointment_id: appointmentId, locale } });
      if (result.error || result.data?.error) throw new Error('payment_unavailable');
      return result.data;
    }
  }
  const result = await supabase.functions.invoke('clinician-settlement', { body: { action, appointment_id: appointmentId } });
  if (result.error || result.data?.error) throw new Error('payment_unavailable');
  return result.data;
}
